(function() {
	'use strict';

	angular.module('quantixApp').factory('ProductSectionConfigService',
			ProductSectionConfigService);

	ProductSectionConfigService.$inject = [ '$resource', '$http','$q' ];

	function ProductSectionConfigService($resource, $http,$q) {


		var _getProductList = function() {

		var deferred = $q.defer();
		var url = 'api/productSectionConfig/getProductList';

		$http.post(url).then(function(response) {

			deferred.resolve(response.data);

		}, function(errResponse) {
			deferred.reject(errResponse);
		});

		return deferred.promise;
		}

		var _getModuleAndSectionData = function(userName) {

			var deferred = $q.defer();
			var url = 'api/productSectionConfig/getModuleAndSection';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _saveModuleAndSectionFlag = function(flagAndSection) {
			return $http({
				method : 'POST',
				url : 'api/productSectionConfig/saveModuleAndSectionFlag',
				headers : {
					'Content-type' : 'application/json'
				},
				data : flagAndSection
			}).success(function(data) {
			}).error(function(data) {
				console.log("Error in updating Flag" + data);

			});
		}

		return {
			getProductList : _getProductList,
			getModuleAndSectionData : _getModuleAndSectionData,
			saveModuleAndSectionFlag : _saveModuleAndSectionFlag
		};
	}
})();
